import { DEV_KEYWORDS, TEST_KEYWORDS, APP_SUBDOMAIN, APP_DEV_SUBDOMAIN, APP_TEST_SUBDOMAIN, OPENSALUD360_SUBDOMAIN, OPENSALUD_SUBDOMAIN, OPENSALUD_TEST_SUBDOMAIN } from '@/constants/subdomains'
import { DEV_ENV, TEST_ENV, PROD_ENV, LOCAL_ENV } from '@/constants/environments'
import { ES_COUNTRY, MX_COUNTRY } from '@/constants/countries'
import { MX_DOMAIN_EXTENSION, ES_DOMAIN_EXTENSION } from '@/constants/domainExtensions'
import { LOCALHOST_DOMAIN, OPENSALUD_DOMAIN, OPENLEGAL_DOMAIN, MENTTUM_DOMAIN } from '@/constants/domains'
import { inOpenlegal, inOpensalud360, inMenttum } from '@/constants/platformNames'
import domains from '_static/domains.json'
import { ES_PREFIX, MX_PREFIX } from '@/constants/countries'
import { MX_COUNTRY_ID, SPAIN_COUNTRY_ID } from '@/constants/db/countries'

export function getEnvironmentName () {
	let environment
	if (process.env.NODE_ENV !== PROD_ENV) {
		environment = process.env.LOCAL_ENVIRONMENT
	} else if (DEV_KEYWORDS.some(keyword => window.location.href.includes(keyword))) {
		environment = DEV_ENV
	} else if (TEST_KEYWORDS.some(keyword => window.location.href.includes(keyword))) {
		environment = TEST_ENV
	} else {
		environment = PROD_ENV
	}
	return environment
}

export function getCountry () {
	return window.location.href.includes(MX_DOMAIN_EXTENSION) ? MX_COUNTRY : ES_COUNTRY
}

export function getBaseDomain () {
	var host = window.location.hostname
	var subdomains = host.split(".")
	var length = subdomains.length

	if (length >= 2) {
			return "." + subdomains[length - 2] + "." + subdomains[length - 1]
	} else {
			return LOCALHOST_DOMAIN
	}
}

export function outerOpensaludMainDomain () {
	let url = window.location.href.toLowerCase();
	return url.indexOf(OPENSALUD_SUBDOMAIN) === -1 && url.indexOf(OPENSALUD_TEST_SUBDOMAIN) === -1
}

export function getPortal () {
	if (window.location.hostname.includes(LOCALHOST_DOMAIN)) {
		return domains.app.local
	}
	const url = window.location.hostname.split('.')
	const envSubdomain = DEV_KEYWORDS.some(keyword => url[0].includes(keyword)) ? APP_DEV_SUBDOMAIN : (TEST_KEYWORDS.some(keyword => url[0].includes(keyword)) ? APP_TEST_SUBDOMAIN : APP_SUBDOMAIN)
	if (window.location.hostname.includes(OPENSALUD_DOMAIN)) {
		let opensalud360suffix = inOpensalud360() ? `-${OPENSALUD360_SUBDOMAIN}` : ''
		return `${envSubdomain}${opensalud360suffix}.${OPENSALUD_DOMAIN}.${url[2] ? url[2] : ES_DOMAIN_EXTENSION}`
	} else if (inOpenlegal()) {
		return `${envSubdomain}.${OPENLEGAL_DOMAIN}.${url[2] ? url[2] : ES_DOMAIN_EXTENSION}`
	} else if (inMenttum()) {
		return `${envSubdomain}-${OPENSALUD360_SUBDOMAIN}.${OPENSALUD_DOMAIN}.${ES_DOMAIN_EXTENSION}`
	}
	return `${envSubdomain}.${OPENSALUD_DOMAIN}.${url[2] ? url[2] : ES_DOMAIN_EXTENSION}`
}

export const environment = getEnvironmentName()

export const inLocalEnv = environment === LOCAL_ENV
export const inDevelopmentEnv = environment === DEV_ENV
export const inStagingEnv = environment === TEST_ENV
export const inProductionEnv = environment === PROD_ENV

export const country = getCountry()
export const inEs = window.location.href.includes(ES_DOMAIN_EXTENSION) || window.location.href.includes(`${MENTTUM_DOMAIN}.com`)
export const inMx = country === MX_COUNTRY

export function getDefaultPhonePrefix () {
	return !inMx ? ES_PREFIX : MX_PREFIX
}

export function getDefaultCountryId () {
	return !inMx ? SPAIN_COUNTRY_ID : MX_COUNTRY_ID
}


// WEBPACK FOOTER //
// ./src/helpers/global.helpers.js